import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../../routing/getFlowKey';
const PURCHASE_PRODUCTISED_FLOWS = [Flow.Purchase];
export const isPurchaseProductisedFlow = () => PURCHASE_PRODUCTISED_FLOWS.includes(getFlowKey());